import React, { useState, useEffect } from 'react';
import { checkProductSafety } from '../../controllers/ScanController';
import '../../views/styles/ScanPage.css';
import BarCodeScanner from '../../components/BarCodeScanner';

const ScanPage = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [scanning, setScanning] = useState(true);
  const [error, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    setScanning(true);
  }, []);

  const handleScan = async (productData) => {
    if (!scanning) return;

    console.log("Scanning result received:", productData);
    setLoading(true);
    setError(null);
    setScanning(false);

    try {
      setStatusMessage("Henter produktdata fra Open Food Facts...");
      const processedData = await checkProductSafety(productData, setStatusMessage);
      console.log("Processed product data:", processedData);
      setResult(processedData);
      setStatusMessage("Produktdata hentet og behandlet.");
    } catch (err) {
      setError('Fejl ved behandling af produktdata.');
      setStatusMessage('');
    } finally {
      setLoading(false);
    }
  };

  const handleNewScan = () => {
    console.log("Restarting scanner...");
    setResult(null);
    setStatusMessage('Klar til at scanne en ny stregkode.');
    setError(null);
    setScanning(true);
  };

  const highlightAllergens = (ingredients, allergens) => {
    let highlightedIngredients = ingredients;
    allergens.forEach(allergen => {
      const regex = new RegExp(`(${allergen.da})`, 'gi');
      highlightedIngredients = highlightedIngredients.replace(regex, '<span class="allergen">$1</span>');
    });
    return highlightedIngredients;
  };

  return (
    <div className="scan-container">
      <h1>Scan en stregkode</h1>

      {scanning ? (
        <div className="webcam-container">
          <BarCodeScanner onResult={handleScan} className="webcam" facingMode="environment" />
        </div>
      ) : (
        <p className="status-message">Scanning stopped. Klik "Scan ny stregkode" for at genstarte.</p>
      )}

      <p className="status-message">{statusMessage}</p>
      {loading && <p>Loading...</p>}
      {error && <p className="error-message">{error}</p>}

      {result && (
        <div className={`result-box ${result.isSafe ? 'safe' : 'not-safe'}`}>
          <h2>
            {result.isSafe ? "SAFEBYTE - Produktet er sikkert!" : "IKKE SAFEBYTE - Produktet er IKKE sikkert!"}
          </h2>
          <div className="result-details">
            <h3>Scan Result:</h3>
            <p><strong>Produktnavn:</strong> {result.productName || 'Ukendt produkt'}</p>
            <p><strong>Ingredienser:</strong> <span dangerouslySetInnerHTML={{ __html: highlightAllergens(result.ingredientsList, result.detectedAllergens) }} /></p>
            <p><strong>Kategorier:</strong> {result.categories || 'Ingen kategoridata tilgængelig'}</p>
            <p>
              <strong>Allergen Matches:</strong>{" "}
              {result.detectedAllergens?.length > 0
                ? result.detectedAllergens.map((a) => `${a.da} (${a.en})`).join(", ")
                : "Ingen allergener fundet"}
            </p>
          </div>
        </div>
      )}
      <button onClick={handleNewScan} className="button">Scan ny stregkode</button>
    </div>
  );
};

export default ScanPage;